import Icon from './Icon'
import Modal from './Modal'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class ImageHighlightStory extends Component {
  static propTypes = {
    image: PropTypes.object.isRequired,
    isExpanded: PropTypes.bool.isRequired,
    onCollapseClick: PropTypes.func.isRequired,
    onExpandClick: PropTypes.func.isRequired,
    title: PropTypes.string
  }

  render() {
    const {
      image,
      isExpanded,
      onCollapseClick,
      onExpandClick,
      title
    } = this.props

    return (
      <div
        className="image-container"
        style={{ backgroundImage: `url(${image.large})` }}
      >
        <div className="insight-focus-modal">
          <Modal
            backdrop={false}
            header={<h4 className="center">{title}</h4>}
            isOpen={isExpanded}
            onCloseClick={onCollapseClick}
          >
            <img
              className="modal-image insight-modal-content"
              src={image.extraLarge}
            />
          </Modal>
        </div>
        <div className="story-expand-bar">
          <Icon
            name="fullscreen"
            className="right cursor"
            onClick={onExpandClick}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/ImageHighlightStory.js